export default "__VITE_PUBLIC_ASSET__b946dad1__"